<template >
	<!-- 订单信息 -->
	<div class="theDefault">
		<div class="theDefault-title">
			<div class="left">
				<router-link to="/mine/my-profile">
					<img v-if="userName.HeadPic" :src="userName.HeadPic" alt="" />
					<img style="border-radius: 50%;" v-else :src="require('@/assets/tourist/avatar.png')" alt="">
				</router-link>
			</div>
			<div class="center">
				<p class="left-p">{{ userName.UserName }}</p>
				<p class="left-img">
					<img v-if="userName.CustTypeName == '普通客户'" src="@/assets/PTKH.png" alt="" />
					<img v-else-if="userName.CustTypeName == '汽修客户'" src="@/assets/QXKH.png" alt="" />
					<img v-else-if="userName.CustTypeName == '汽配客户'" src="@/assets/QPKH.png" alt="" />
				<div v-if="userName.IsRealNameAuth">
					<img class="rZheng" style="width: 50px; height: 20px; " src="@/assets/real-name/renzhneg.png"
						alt=""/>
				</div>
				</p>

				<!-- <p style="font-size: 18px;color: rgba(56, 56, 56, 1);">
          邀请码：
        <p class="orange">18961833036</p>&nbsp;
        </p> -->
			</div>
			<router-link to="/mine/capital-account">
				<div class="right" style="cursor: pointer">
					<!-- <router-link to="/mine/my-profile">修改资料</router-link> -->

					<div class="right-title">资金账户</div>
					<div class="right-fol">
						<div class="item">
							<div class="y">￥{{ userName.CustResidualMargin || "0" }}</div>
							<div class="morevo">可用保证金</div>
						</div>
						<div class="item">
							<div class="y">￥{{ userName.CustFreezedMargin || "0" }}</div>
							<div class="morevo">冻结保证金</div>
						</div>
						<div class="item">
							<div class="y">￥{{ userName.CustUsedMargin || "0" }}</div>
							<div class="morevo">占用保证金</div>
						</div>


					</div>
				</div>
			</router-link>
		</div>
		<div class="Myorder">
			<div class="Myorder-title">
				<div class="left">我的订单</div>
				<!-- <div class="right">查看更多</div> -->
			</div>
			<div class="itemBox">
				<div class="item" @click="ordeRlistPath('DFK')">
					<img src="@/assets/dfk.png" alt="" />
					<span v-if="OrderQtyList[0]">{{ OrderQtyList[0].Qty }}</span>
					<div>待付款</div>
				</div>
				<div class="item" @click="ordeRlistPath('DFH')">
					<img src="@/assets/DFH.png" alt="" />
					<span v-if="OrderQtyList[1]">{{ OrderQtyList[1].Qty }}</span>

					<div>待发货</div>
				</div>
				<div class="item" @click="ordeRlistPath('YFH')">
					<!-- <img src="@/assets/ysh.png" alt="" /> -->
					<img src="@/assets/dsh.png" alt="" />

					<span v-if="OrderQtyList[2]">{{ OrderQtyList[2].Qty }}</span>

					<div>已发货</div>
				</div>
				<div class="item" @click="ordeRlistPath('TK')">
					<img src="@/assets/TH.png" alt="" />
					<span v-if="OrderQtyList[1]">{{ OrderQtyList[3].Qty }}</span>

					<div>退货</div>
				</div>
				
				<div class="item" @click="ordeRlistPath('')">
					<img src="@/assets/all.png" alt="" />

					<div>查看全部</div>
				</div>
				<div class="item">
					<img src="@/assets/jingjia.png" alt="" />
					<!-- <span>0</span> -->

					<div>竞价订单</div>
				</div>
			</div>
		</div>
		<div class="Myorder" style="height: 300px">
			<div class="Myorder-title">
				<div class="left">我的主营业务</div>
				<router-link to="/mine/main-business">
					<div class="right">选择更多 <i class="el-icon-arrow-right"></i></div>
				</router-link>
			</div>
			<div class="foolt">
				<div>已选</div>
				<div style="display: flex; align-items: center">
					<div style="width: 60px; margin-top: 5px">品牌:</div>
					<div class="item" v-for="(item, index) in brandList" :key="index">
						{{ item.BrandName || item.Country }}
					</div>
				</div>

				<div style="display: flex; align-items: center">
					<div style="width: 60px; margin-top: 5px">配件:</div>
					<div class="item" v-for="(item, index) in accessoriesList" :key="index">
						{{ item.AutoPartsName || item.StatisticsName }}
					</div>
				</div>
			</div>
		</div>
		<div class="Carbonaccount" style="height: 300px">
			<div class="Carbonaccount-title">
				<div class="left">我的碳账户</div>
				<div class="right">环保知识早知道 <span>绿色消费</span> 低碳生活</div>
			</div>
			<div class="canvas">
				<div>
					<div class="top">
						<div class="t1">
							<img src="@/assets/ger.png" alt="">
							<span>个人累计减碳</span>
						</div>
						<div class="t2">
							{{ Emission.CarbonEmission }}KG
						</div>
					</div>
					<div class="buttom">
						<div class="b1">
							<img src="@/assets/xsshu.png" alt="">
							<span>相当于种下</span>
						</div>
						<div class="b2">
							<span>{{ Emission.CedarTree }}</span> 棵雪松树
						</div>
					</div>
				</div>
				<div class="echartsCanvas" ref="treeChartCommon" style="width: 500px;" :style="{ height: '242px' }"></div>
				<div class="gxian">减碳贡献TOP5</div>

				<div class="chakanXq">
					<router-link to="/mine/carbonAccount">
						查看详情

						<i style="color: #fe7648;" class="el-icon-arrow-right"></i>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import headerPic from "@/assets/rzLogo.png"
import { GetMainBusiness } from "@/api/mainbusiness.js"
import { OrderQty, GetMyInfo, GetCarbonEmission, GetALLCarbonEmission } from "@/api/user.js"
export default {
	data() {
		return {
			headerPic: headerPic,
			list: [],
			userName: {},
			GetMyInfoList: {},
			OrderQtyList: {},
			// 品牌
			brandList: [],
			// 配件
			accessoriesList: [],
			pageForm: {
				PageIndex: 1,
				PageSize: 20
			},
			// 减碳
			Emission: {},
			pieData: [],
			chartData: {
				pieData: [

				],

			}
		}
	},
	created() {




	},
	mounted() {
		this.$parent.pathClick()
		GetCarbonEmission().then(res => {
			// console.log(res)
			this.Emission = res
		})
		this.GetMyProfileCli()
		GetALLCarbonEmission({ SearchType: '2' }).then(res => {
			// console.log(res)
			this.pieData = res.list.map(item => {
				// console.log(item)
				return {
					name: item.Name + ":\xa0" + item.CO2Impairment + 'KG',
					value: item.CO2Impairment
				}
			})

			this.showChart()

		})
	},
	methods: {
		showChart() {
			// 基于准备好的dom，初始化echarts实例
			let newPromise = new Promise((resolve) => {
				resolve()
			})
			//然后异步执行echarts的初始化函数
			newPromise.then(() => {
				//	此dom为echarts图标展示dom
				var myChart = this.$echarts.init(this.$refs.treeChartCommon)
				myChart.clear()

			})

			var myChart = this.$echarts.init(this.$refs.treeChartCommon)
			myChart.clear()

			console.log(this.pieData)
			// const list = this.pieData
			const list = this.pieData.slice(0, 4)
			if (this.pieData.length == 0) {
				var a = '0'
				// console.log(list[0].value)
			} else {
				const list = this.pieData.slice(0, 4)
				if (list.length == 1) var a = Number(list[0].value)
				if (list.length == 2) var a = Number(list[0].value) + Number(list[1].value)
				if (list.length == 3) var a = Number(list[0].value) + Number(list[1].value) + Number(list[2].value)
				if (list.length == 4) var a = Number(list[0].value) + Number(list[1].value) + Number(list[2].value) + Number(list[3].value)
				if (list.length == 5) var a = Number(list[0].value) + Number(list[1].value) + Number(list[2].value) + Number(list[3].value) + Number(list[4].value)
			}
			// console.log(Number(list[0].value)+ Number(list[1].value) )
			console.log(a)
			// 指定图表的配置项和数据
			var option = {
				//标题
				title: {
					text: this.chartData.pieTitle,
					x: 'center', //水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
					y: 'bottom', //垂直安放位置，默认为top，可选为：'top' | 'bottom' | 'center' | {number}（y坐标，单位px）
					textStyle: {
						fontFamily: 'Microsoft YaHei',
						fontSize: 14,
						fontWeight: 'normal',
						color: '#333333',
					},
					left: '35%',
					top: '-10%',
					textAlign: 'center', // 标题始终和图表保持居中
				},
				// 设置圆环渐变色

				color: ['#ffeb3b', '#fe7648', '#1d2089', '#7948ea', '#ff5733'],
				legend: {
					itemWidth: 16,
					itemHeight: 16,
					icon: 'circle',
					x: 'right',
					y: 'center',
					orient: 'vertical', //设置图例排列纵向显示
					align: 'left', //设置图例中文字位置在icon标识符的右侧
					left: '56%',
					top: '15%',
					itemGap: 10, //设置图例之间的间距
					padding: [0, 10, 10, 0], //设置图例与圆环图之间的间距
					fontSize: 16,
					// formatter: function (name) {
					// 	//该函数用于设置图例显示后的百分比
					// 	var total = 0
					// 	var value
					// 	list.forEach((item) => {
					// 		total += item.value
					// 		if (item.name === name) {
					// 			value = item.value
					// 		}
					// 	})
					// 	var p = ((value / total) * 100).toFixed(1) //求出百分比,保留2位小数
					// 	// return `${name}  ${value}件  ${p}%`
					// 	return `{a|${name}}{b|${value}件}{c|${p}%}` //返回出图例所显示的内容是名称+百分比
					// },
					// 自定义图例文字样式
					textStyle: {
						fontSize: 18,
						padding: [0, 10, 0, 0],
						// rich: {
						//     a: {
						//         color: '#ffeb3b',
						//         padding: [0, 10, 0, 0],
						//         fontSize: 14,
						//     },
						//     b: {
						//         color: '#666666',
						//         padding: [0, 10, 0, 0],
						//         fontSize: 12,
						//     },
						//     c: {
						//         color: '#666666',
						//         fontSize: 12,
						//     },
						// },
					},
				},
				graphic: [
					// 设置圆环内文字始终在圆环的正中间
					{
						type: 'group',
						left: '25%',
						top: '36%',
						bounding: 'raw',
						color: '#333333',
						textStyle: {
							fontFamily: 'Microsoft YaHei',
							fontSize: 12,
							fontWeight: 'normal',
							color: '#71d86e',
						},
						children: [
							{
								type: 'text',
								style: {
									text: a,
									fontSize: 20,
									fontWeight: 600,
									fill: '#71d86e', //文字的颜色
									textVerticalAlign: 'middle',
									textAlign: 'center',
								},
							},
						],
					},
					{
						type: 'group',
						left: '25%',
						top: '46%',
						bounding: 'raw',
						children: [
							{
								type: 'text',
								style: {
									text: 'KG',
									fontSize: 22,
									fontWeight: 600,
									fill: '#71d86e', //文字的颜色
									textVerticalAlign: 'middle',
									textAlign: 'center',
								},
							},
						],
					},
				],
				calculable: true,
				series: [
					{
						name: '',
						type: 'pie',
						radius: ['40%', '50%'], //饼图的半径，数组的第一项是内半径，第二项是外半径。支持设置成百分比，相对于容器高宽中较小的一项的一半。可以将内半径设大显示成圆环图, 设置内半径和外半径，形成环状
						center: ['25%', '40%'], //饼图的中心(圆心)坐标，数组的第一项是横坐标，第二项是纵坐标。支持设置成百分比，设置成百分比时第一项是相对于容器宽度，第二项是相对于容器高度。这里的center一旦设置, 则 graphic/legend 里的内容位置也要相应进行调整
						// roseType: 'radius',
						barWidth: '10',
						itemStyle: {
							// normal: {
							//     label: {
							//         show: false,
							//     },
							//     labelLine: {
							//         show: true,
							//     },
							// },
							emphasis: {
								shadowColor: '#000',
								shadowBlur: 10,
								// label: {
								//   show: true,
								// },
							},
						},
						data: list,
					},

				],
			}
			// 使用刚指定的配置项和数据显示图表。
			myChart.setOption(option)

			window.addEventListener('resize', function () {
				//浏览器大小调整echarts随之改变
				myChart.resize()
			})
		},

		// 跳转到我的订单页面
		ordeRlistPath(e) {
			console.log(e)
			this.$router.push(`/mine/ordeRlist/?StatusCode=${e}`)
			this.$parent.pathClick();
		},
		// 获取我的资料信息 、 订单数量
		GetMyProfileCli() {
			GetMyInfo().then((res) => {
				this.userName = res
				// console.log(res, "1")
			})
			// GetMyInfo().then((res) => {
			//   console.log(res,'2')

			//   this.GetMyInfoList = res;
			// });
			OrderQty().then((res) => {
				this.OrderQtyList = res
			})
			// 获取主营业务数据
			GetMainBusiness({ PageIndex: 1, PageSize: 20 }).then((res) => {
				this.brandList = res.BrandList.List.slice(0, 6)
				this.accessoriesList = res.AutoList.List.slice(0, 6)
			})
		},
		path() {
			return this.$route.fullPath
		}
	}
}
</script>

<style lang="scss">
.theDefault {
	margin-top: 45px;
	// margin-left: -10px;
	width: 1100px;
	margin-bottom: 40px;

	.theDefault-title {
		height: 220px;
		background-color: #fff;
		width: 1100px;
		padding: 20px;
		display: flex;
		// align-items: center;
		// justify-content: space-between;

		.left {
			display: flex;
			align-items: center;
			margin-left: 40px;

			img {
				width: 150px;
				height: 150px;
				border-radius: 50%;
				margin-right: 20px;
			}
		}

		.center {
			margin-left: 10px;
			width: 170px;
			border-right: 1px solid #6265ad;

			.left-p {
				margin-top: -5px;
				// margin-bottom: 12px;
				color: #000;
				font-size: 20px;
				font-weight: 700;
				margin-top: 20px;
			}

			.left-img {
				margin-bottom: 20px;
				margin-top: 5px;

				img {
					width: 108px;
					height: 35px;
				}

				.rZheng {
					width: 40px;
					height: 15px;
				}
			}

			.orange {
				font-size: 18px;
			}
		}

		.right {
			width: 495px;
			margin-left: 105px;
			margin-top: 15px;

			.right-title {
				font-size: 20px;
				font-weight: 700;
			}

			.right-fol {
				margin-top: 45px;
				display: flex;
				justify-content: space-between;
				text-align: center;

				.item {
					.y {
						font-size: 24px;
						font-weight: 700;
						color: #fe7648
					}

					.morevo {
						margin-top: 15px;
						font-size: 18px;
						color: rgba(56, 56, 56, 1);
					}
				}
			}
		}
	}

	.Myorder {
		width: 1100px;
		height: 270px;
		opacity: 1;
		background: rgba(255, 255, 255, 1);
		margin-top: 15px;
		padding: 0 40px;

		.Myorder-title {
			font-size: 20px;
			height: 70px;
			line-height: 70px;
			border-bottom: 1px solid #8385be;
			display: flex;
			justify-content: space-between;

			.right {
				font-size: 16px;
				cursor: pointer;
				margin-right: 20px;
			}
		}

		i {
			color: #fe7648;
			font-weight: 600;
		}

		.itemBox {
			display: flex;
			justify-content: space-between;
			text-align: center;

			.item {
				cursor: pointer;
				width: 25%;
				margin-top: 40px;
				position: relative;

				span {
					position: absolute;
					top: -13px;
					left: 110px;
					padding: 1px 6px;
					background-color: #fe7648;
					color: #fff;
					font-size: 12px;
					border-radius: 50%;
				}

				img {
					margin-bottom: 25px;
				}
			}
		}

		.foolt {
			margin-top: 10px;

			.item {
				overflow: hidden; //超出的文本隐藏
				text-overflow: ellipsis; //溢出用省略号显示
				white-space: nowrap; // 默认不换行；
				padding: 0 5px;
				margin-top: 10px;
				width: 150px;
				height: 50px;
				line-height: 50px;
				border-radius: 8px;
				background: rgba(243, 248, 254, 1);
				border: 1px solid rgba(29, 32, 137, 1);
				text-align: center;
				font-size: 18px;
				font-weight: 400;
				color: rgba(29, 32, 137, 1);
				float: left;
				margin-right: 10px;
			}
		}
	}

	.Carbonaccount {
		width: 1100px;
		height: 270px;
		opacity: 1;
		background: rgba(255, 255, 255, 1);
		margin-top: 15px;
		padding: 0 40px;

		.Carbonaccount-title {
			height: 70px;
			line-height: 70px;
			border-bottom: 1px solid #8385be;
			display: flex;

			.left {
				font-size: 22px;
			}

			// justify-content: space-between;
			.right {
				margin-left: 20px;
				font-size: 18px;
				font-weight: 600;
				color: rgba(64, 191, 115, 1);

				span {
					margin: 0 7px 0 27px;
				}
			}
		}

		.canvas {
			display: flex;

			.top {
				margin-top: 25px;

				.t1 {
					display: flex;
					align-items: center;

					span {
						font-size: 16px;
					}

					img {
						height: 16px;
						margin-right: 5px;
					}
				}

				.t2 {
					color: #40bf73;
					font-weight: 600;
					font-size: 24px;
				}
			}

			.buttom {
				margin-top: 50px;

				.b1 {
					display: flex;
					align-items: center;

					span {
						font-size: 16px;
					}

					img {
						height: 16px;
						margin-right: 5px;
					}
				}

				.b2 {
					span {
						color: #40bf73;
						font-weight: 600;
						font-size: 24px;
					}
				}
			}

			.echartsCanvas {
				margin-left: 80px;
				margin-top: 30px;
				// position: relative;
			}

			.gxian {
				// position: absolute;
				// left: 50px;
				margin-left: -430px;
				margin-top: 25px;
				width: 600px;
			}

			.chakanXq {
				padding-top: 105px;
				cursor: pointer;
			}
		}
	}

}</style>
